import { NavLink } from "react-router-dom"
import "../CSS/courses.css"

const Courses_Hp = () => {
    const courses = ["/FullStack.jpeg", "/SoftSkill.jpeg", "/python.jpeg", "/FrontDev.jpeg"]


    return (
        <div>
            <div className="courses-hp">
                {courses.map((img, index) => {

                    return (
                        <div className="courses-card courses-card-hover">
                            <img src={img}></img>
                        </div>
                    )
                })}
            </div>
            <div><NavLink to="/courses" activeClassName="is-active" className="course-buttons">View All Courses</NavLink></div>
        </div>
    )
}
export default Courses_Hp;